export const OperatorSelectList = [
  { label: 'Equals', value: 'EQUALS' },
  { label: 'Between', value: 'BETWEEN' },
  { label: 'is', value: 'IS' },
  { label: 'Is not', value: 'IS_NOT' },
  { label: 'Is in', value: 'IS_IN' },
  { label: 'Is not in', value: 'IS_NOT_IN' },
  { label: 'Greater than', value: 'GREATER_THAN' },
  { label: 'Less than', value: 'LESS_THAN' },
];
